import clsx from "clsx";
import { Button } from "@components";

export default function Text({ title, subheader, textRight, green = "", customTextClass = "", buttonLink, buttonText }) {
    const containerStyle = clsx(
        textParentStyle +
            green +
            (textRight ? " rounded-r-lg" : " rounded-l-lg"),
    );

    const innerContainerStyle = clsx(
        textChildStyle + (textRight ? " m-10" : " ml-10") + (customTextClass ? ` ${customTextClass}` : ""),
    );
    return (
        <div className={containerStyle}>
            <div className={innerContainerStyle}>
                <div className="mb-10 text-xl font-bold md:text-5xl">
                    {title}
                </div>
                <div className="text-lg lg:text-2xl solutions-content" dangerouslySetInnerHTML={{ __html: subheader }}></div>
                {buttonLink && buttonText && (
                    <div className="mt-6">
                        <Button to={buttonLink} className="w-[200px] md:w-[240px]">
                            {buttonText}
                        </Button>
                    </div>
                )}
            </div>
        </div>
    );
}

const textParentStyle = clsx(
    "flex items-center justify-center h-full max-w-full md:w-1/2 ",
);
const textChildStyle = clsx("flex max-w-[600px] flex-col justify-center p-0 lg:p-10");
